import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-382fb4dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

import MaterialShapeContainer from './../material-shape-container.vue';
import { IMaterialShapedIconProps } from './material-shaped-icon.types';



export default /*#__PURE__*/_defineComponent({
  __name: 'material-shaped-icon',
  props: {
    props: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MaterialShapeContainer, {
    props: {
            shape: 'ten-pointed-smooth-shape',
            strokeWidth: 25,
        },
    class: "material-shaped-icon"
  }, {
    default: _withCtx(() => [
      (__props.props.iconLocal)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "material-shaped-icon__icon",
            src: require(`@/assets/icons/emojis/${__props.props.iconLocal}`)
          }, null, 8, _hoisted_1))
        : (__props.props.iconCompleteUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "material-shaped-icon__icon",
              src: __props.props.iconCompleteUrl
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})